module.exports = __webpack_public_path__ + "img/clogo8.4129ab4a.png";